import { render, staticRenderFns } from "./leader-transfer.vue?vue&type=template&id=e4ed8762&scoped=true"
import script from "./leader-transfer.vue?vue&type=script&lang=js"
export * from "./leader-transfer.vue?vue&type=script&lang=js"
import style0 from "./leader-transfer.vue?vue&type=style&index=0&id=e4ed8762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ed8762",
  null
  
)

export default component.exports